import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Action, State, StateContext } from '@ngxs/store';
import * as actions from './congrats.actions';
import { name } from './congrats.consts';
import { CongratsStateModel } from './congrats.state-model';

const defaults = {};

@State<CongratsStateModel>({
  name,
  defaults,
})
@Injectable()
export class LoaderState {
  readonly #snackBar: MatSnackBar;
  constructor(snackBar: MatSnackBar) {
    this.#snackBar = snackBar;
  }

  @Action(actions.ShowCongrats)
  showCongrats(
    ctx: StateContext<CongratsStateModel>,
    { payload }: actions.ShowCongrats
  ) {
    const message = payload || 'Operación finalizada correctamente';
    this.#snackBar.open(message, '', { duration: 5000 });
  }

  @Action(actions.ShowErrorMessage)
  showErrorMessage(
    ctx: StateContext<CongratsStateModel>,
    { payload }: actions.ShowCongrats
  ) {
    const message = payload || 'Operación finalizada con errores';
    this.#snackBar.open(message, '', {
      duration: 5000,
    });
  }
}
